import * as React from "react";
import { useState } from "react";
import { useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { getBoardByCompany, postFormLink } from "@/services/directors";
// helpers
import { useAccessPermission } from "@/helpers/acessPermission";

// UI
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Download, PenLine, X, Copy } from "lucide-react";
import TableSkeleton from "../skeleton/TableSkeleton";

import { useNavigate } from "@tanstack/react-router";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
  DialogDescription,
} from "@/components/ui/dialog";

import { useToast } from "@/components/ui/use-toast";
import dayjs from "dayjs";
import { Input } from "@/components/ui/input";

interface EditProps {
  state?: boolean;
  count?: number;
  id?: string;
  formId?: string;
}
interface EditInfoProps {
  onClose?: () => void;
  open: boolean;
  formId: string;
  directorId: string;
  isDirectorForm: boolean;
  boardId: string;
}
interface FormTypeProps {
  formTypeId: string;
}
import type { FC } from "react";
// First Functional Component

const Government: React.FC<FormTypeProps> = ({ formTypeId }) => {
  const directorId = String(localStorage.getItem("directorId")); // Get year from local storage

  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [selectedFormId, setSelectedFormId] = useState("");
  const toshow = () => {
    setShow(true);
  };
  const { director_Evaluation_Report } = useAccessPermission();

  const { data, isLoading } = useQuery({
    queryKey: ["boards", formTypeId],
    queryFn: () => getBoardByCompany({ formTypeId, directorId }),
  });
  if (isLoading) return <TableSkeleton />;

  const Edit: FC<EditProps> = ({ id }) => {
    return (
      <div className="flex gap-x-2 items-center">
        <Button
          onClick={() => {
            setSelectedFormId(id || "");
            toshow();
          }}
          variant="secondary"
          className="flex items-center text-blue-500 rounded-md border border-gray-300"
        >
          ສ້າງລິ້ງ
        </Button>
        <Button
          onClick={() => {
            try {
              localStorage.setItem("Question", id || "");
              navigate({
                to: "/report/director/details/answer",
                replace: true,
              });
            } catch (error) {
              console.error("Error saving question ID:", error);
            }
          }}
          variant="secondary"
          className="flex items-center text-blue-500 rounded-md border border-gray-300"
        >
          ຕອບ
        </Button>
      </div>
    );
  };
  const ToCheck: FC<EditProps> = ({ state, count }) => {
    console.log("state", count);
    if (state === true) {
      return <p className="w-full text-green-500">ຕອບແລ້ວ {count}</p>;
    }
    return <p className="text-red-500">ຍັງບໍ່ຕອບ</p>;
  };

  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ລຳດັບ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ປະຈຳປີ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ຊື່ແບບຟອມ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ວັນທີເລີ່ມ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ວັນທີສິ້ນສຸດ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ສະຖານະ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ຈັດການ
            </TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {data?.data?.map((invoice, index) => (
            <TableRow key={invoice?.id} className="cursor-pointer">
              <TableCell className="border">{index + 1}</TableCell>
              <TableCell className="border">{invoice?.yearly}</TableCell>
              <TableCell className="border text-start">
                {invoice?.name}
                {invoice?.formId}111222
              </TableCell>
              <TableCell className="border text-start">
                {invoice?.startDate
                  ? dayjs(invoice?.startDate).format("DD/MM/YYYY")
                  : "-"}
              </TableCell>
              <TableCell className="border">
                {invoice?.expiryDate
                  ? dayjs(invoice?.expiryDate).format("DD/MM/YYYY")
                  : "-"}
              </TableCell>
              <TableCell className="border">
                {director_Evaluation_Report.isWrite && (
                  <ToCheck
                    state={invoice?.isAnswered}
                    count={invoice?.answerCount}
                  />
                )}
              </TableCell>
              <TableCell className="border text-start">
                {director_Evaluation_Report.isUpdate && (
                  <Edit id={invoice?.id} />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {show ? (
        <ShowInfomation
          open={show}
          onClose={() => setShow(false)}
          formId={selectedFormId}
          isDirectorForm={false}
          directorId={directorId}
        />
      ) : null}
    </div>
  );
};

const Workplace: React.FC<FormTypeProps> = ({ formTypeId }) => {
  const directorId = String(localStorage.getItem("directorId")); // Get year from local storage

  const navigate = useNavigate();
  const [selectedFormId, setSelectedFormId] = useState("");

  const [show, setShow] = React.useState(false);
  const toshow = () => {
    setShow(true);
  };
  const { director_Evaluation_Report } = useAccessPermission();
  const { data, isLoading } = useQuery({
    queryKey: ["boards", formTypeId],
    queryFn: () => getBoardByCompany({ formTypeId, directorId }),
  });
  if (isLoading) return <TableSkeleton />;
  const Edit: FC<EditProps> = ({ id }) => {
    return (
      <div className="flex gap-x-2 items-center">
        <Button
          onClick={() => {
            setSelectedFormId(id);
            toshow();
          }}
          variant="secondary"
          className="flex items-center text-blue-500 rounded-md border border-gray-300"
        >
          ສ້າງລິ້ງ
        </Button>
        <Button
          onClick={() => {
            try {
              localStorage.setItem("Question", id || "");
              navigate({
                to: "/report/director/details/answer",
                replace: true,
              });
            } catch (error) {
              console.error("Error saving question ID:", error);
            }
          }}
          variant="secondary"
          className="flex items-center text-blue-500 rounded-md border border-gray-300"
        >
          ຕອບ
        </Button>
      </div>
    );
  };
  const ToCheck: FC<EditProps> = ({ state, count }) => {
    if (state === true) {
      return <p className="w-full text-green-500">ຕອບແລ້ວ {count}</p>;
    }
    return <p className="text-red-500">ຍັງບໍ່ຕອບ</p>;
  };

  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ລຳດັບ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ປະຈຳປີ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ຊື່ແບບຟອມ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ວັນທີເລີ່ມ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ວັນທີສິ້ນສຸດ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ສະຖານະ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ຈັດການ
            </TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {data?.data?.map((invoice, index) => (
            <TableRow key={invoice?.id} className="cursor-pointer">
              <TableCell className="border">{index + 1}</TableCell>
              <TableCell className="border">{invoice?.yearly}</TableCell>
              <TableCell className="border text-start">
                {invoice?.name}
              </TableCell>
              <TableCell className="border text-start">
                {invoice?.startDate
                  ? dayjs(invoice?.startDate).format("DD/MM/YYYY")
                  : "-"}
              </TableCell>
              <TableCell className="border">
                {invoice?.expiryDate
                  ? dayjs(invoice?.expiryDate).format("DD/MM/YYYY")
                  : "-"}
              </TableCell>
              <TableCell className="border">
                {director_Evaluation_Report.isWrite && (
                  <ToCheck
                    state={invoice?.isAnswered}
                    count={invoice?.answerCount}
                  />
                )}
              </TableCell>
              <TableCell className="border text-start">
                {director_Evaluation_Report.isUpdate && (
                  <Edit id={invoice?.id} />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {show && (
        <ShowInfomation
          open={show}
          onClose={() => setShow(false)}
          formId={selectedFormId}
          isDirectorForm={false}
          directorId={directorId}
        />
      )}
    </div>
  );
};

const Board: React.FC<FormTypeProps> = ({ formTypeId }) => {
  const directorId = String(localStorage.getItem("directorId")); // Get year from local storage
  const navigate = useNavigate();

  const [show, setShow] = React.useState(false);
  const [selectedFormId, setSelectedFormId] = useState("");
  const toshow = () => {
    setShow(true);
  };
  const { director_Evaluation_Report } = useAccessPermission();
  const { data, isLoading } = useQuery({
    queryKey: ["boards", formTypeId],
    queryFn: () => getBoardByCompany({ formTypeId, directorId }),
  });
  if (isLoading) return <TableSkeleton />;

  const Edit: FC<EditProps> = ({ id }) => {
    return (
      <div className="flex gap-x-2 items-center">
        <Button
          onClick={() => {
            setSelectedFormId(id);
            toshow();
          }}
          variant="secondary"
          className="flex items-center text-blue-500 rounded-md border border-gray-300"
        >
          ສ້າງລິ້ງ
        </Button>
        <Button
          onClick={() => {
            try {
              localStorage.setItem("Question", id || "");
              navigate({
                to: "/report/director/details/answer",
                replace: true,
              });
            } catch (error) {
              console.error("Error saving question ID:", error);
            }
          }}
          variant="secondary"
          className="flex items-center text-blue-500 rounded-md border border-gray-300"
        >
          ຕອບ
        </Button>
      </div>
    );
  };
  const ToCheck: FC<EditProps> = ({ state, count }) => {
    if (state === true) {
      return <p className="w-full text-green-500">ຕອບແລ້ວ {count || " "}</p>;
    }
    return <p className="text-red-500">ຍັງບໍ່ຕອບ</p>;
  };

  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ລຳດັບ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ປະຈຳປີ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ຊື່ແບບຟອມ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ວັນທີເລີ່ມ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ວັນທີສິ້ນສຸດ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ສະຖານະ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ຈັດການ
            </TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {data?.data?.map((invoice, index) => (
            <TableRow key={invoice?.id} className="cursor-pointer">
              <TableCell className="border">{index + 1}</TableCell>
              <TableCell className="border">{invoice?.yearly}</TableCell>
              <TableCell className="border text-start">
                {invoice?.name}
              </TableCell>
              <TableCell className="border text-start">
                {invoice?.startDate
                  ? dayjs(invoice?.startDate).format("DD/MM/YYYY")
                  : "-"}
              </TableCell>
              <TableCell className="border">
                {invoice?.expiryDate
                  ? dayjs(invoice?.expiryDate).format("DD/MM/YYYY")
                  : "-"}
              </TableCell>
              <TableCell className="border">
                {director_Evaluation_Report.isWrite && (
                  <ToCheck
                    state={invoice?.isAnswered}
                    count={invoice?.answerCount}
                  />
                )}
              </TableCell>
              <TableCell className="border text-start">
                {director_Evaluation_Report.isUpdate && (
                  <Edit id={invoice?.id} />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {show ? (
        <ShowInfomation
          open={show}
          onClose={() => setShow(false)}
          formId={selectedFormId}
          isDirectorForm={false}
          directorId={directorId}
        />
      ) : null}
    </div>
  );
};

const Yourself: React.FC<FormTypeProps> = ({ formTypeId }) => {
  const directorId = String(localStorage.getItem("directorId")); // Get year from local storage
  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [selectedFormId, setSelectedFormId] = useState("");
  const toshow = () => setShow(true);
  const { director_Evaluation_Report } = useAccessPermission();

  const { data, isLoading } = useQuery({
    queryKey: ["directorId", formTypeId],
    queryFn: () => getBoardByCompany({ formTypeId, directorId }),
  });

  if (isLoading) return <TableSkeleton />;

  const Edit: FC<EditProps> = ({ state, id, formId }) => {
    const navigate = useNavigate();
    const handleClick = () => {
      try {
        localStorage.setItem("Question", id || "");
        navigate({
          to: "/report/director/details/answer",
          replace: true,
        });
      } catch (error) {
        console.error("Error saving question ID:", error);
      }
    };

    // Don't conditionally return JSX based on state
    return (
      <div className="flex gap-x-2 items-center">
        <Button
          onClick={() => {
            toshow();
            setSelectedFormId(id);
          }}
          variant="secondary"
          className="flex items-center text-blue-500 rounded-md border border-gray-300"
        >
          ສ້າງລິ້ງ
        </Button>
        {!state && (
          <Button
            onClick={handleClick}
            variant="secondary"
            className="flex items-center text-blue-500 rounded-md border border-gray-300"
          >
            ຕອບ
          </Button>
        )}
      </div>
    );
  };

  const ToCheck: FC<EditProps> = ({ state }) => {
    if (state === true) {
      return <p className="w-full text-green-500">ຕອບແລ້ວ</p>;
    }
    return <p className="text-red-500">ຍັງບໍ່ຕອບ </p>;
  };

  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ລຳດັບ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ປະຈຳປີ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ຊື່ແບບຟອມ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ວັນທີເລີ່ມ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ວັນທີສິ້ນສຸດ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ສະຖານະ
            </TableHead>
            <TableHead className="py-3 text-black bg-gray-100 border border-gray-300 text-start">
              ຈັດການ
            </TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {data?.data?.map((invoice, index) => (
            <TableRow key={invoice?.id} className="cursor-pointer">
              <TableCell className="border">{index + 1}</TableCell>
              <TableCell className="border">{invoice?.yearly}</TableCell>
              <TableCell className="border text-start">
                {invoice?.name}
              </TableCell>
              <TableCell className="border text-start">
                {invoice?.startDate
                  ? dayjs(invoice?.startDate).format("DD/MM/YYYY")
                  : "-"}
              </TableCell>
              <TableCell className="border">
                {invoice?.expiryDate
                  ? dayjs(invoice?.expiryDate).format("DD/MM/YYYY")
                  : "-"}
              </TableCell>
              <TableCell className="border">
                {director_Evaluation_Report.isWrite && (
                  <ToCheck state={invoice?.isAnswered} />
                )}
              </TableCell>
              <TableCell className="border text-start">
                {director_Evaluation_Report.isUpdate && (
                  <Edit
                    state={invoice?.isAnswered}
                    id={invoice?.id}
                    formId={invoice?.formId}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {show ? (
        <ShowInfomation
          open={show}
          onClose={() => setShow(false)}
          formId={selectedFormId}
          isDirectorForm={false}
          directorId={directorId}
        />
      ) : null}
    </div>
  );
};
//import { useToast } from "@/components/ui/use-toast";

const ShowInfomation: FC<EditInfoProps> = ({
  onClose,
  open,
  formId,
  isDirectorForm,
  directorId,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { data, isLoading } = useQuery({
    queryKey: ["links", formId],
    queryFn: () =>
      postFormLink({
        formId,
        directorId: directorId, // Add directorId parameter

        isDirectorForm: true,
      }),
    enabled: !!formId && !!directorId, // Only run query when we have both IDs
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  const { toast } = useToast();
  const ToCopypass = () => {
    if (data?.data?.password) {
      navigator.clipboard
        .writeText(`${data?.data?.password}`)
        .then(() => {
          toast({
            title: "Copied paswork.",
            description: `${data?.data?.password}`,
          });
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };
  const ToCopy = () => {
    if (inputRef.current) {
      navigator.clipboard
        .writeText(inputRef.current.value)
        .then(() => {
          toast({
            title: "Copied successfully.",
            description: inputRef.current.value,
          });
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="fixed max-w-3xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <X />
        </button>

        <DialogHeader className="flex justify-between items-center mt-4 bg-gray-50">
          <DialogTitle className="text-lg font-semibold text-center">
            ການສ້າງລິ້ງ ແລະ ລະຫັດຜ່ານ
          </DialogTitle>
          <DialogDescription>ກະລຸນາກັອບປີ້ ແລະ ລະຫັດຜ່ານ </DialogDescription>
        </DialogHeader>

        {/* Form Fields */}
        <form className="flex flex-col items-center space-y-4 w-full h-60">
          <div className="flex flex-col gap-y-4 w-10/12">
            <p className="font-bold">
              ລິ້ງ <span className="text-red-500">*</span>
            </p>
            <div className="flex justify-between items-center w-full">
              {isLoading ? (
                <Input
                  ref={inputRef}
                  className="max-w-md text-lg text-blue-500 underline truncate border-none cursor-pointer focus:outline-none focus:border-none"
                  value="Loading..."
                  readOnly
                />
              ) : (
                <Input
                  ref={inputRef}
                  className="max-w-md text-lg text-blue-500 underline truncate border-none cursor-pointer focus:outline-none focus:border-none"
                  value={data?.data?.link}
                  readOnly
                />
              )}
              <button
                type="button"
                // variant="outline"
                onClick={ToCopy}
                className="flex gap-x-2 border-none"
              >
                ກັອບປີ້ລິ້ງ <Copy />
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-y-4 w-10/12">
            <p className="font-bold">
              ລະຫັດຜ່ານ <span className="text-red-500">*</span>
            </p>
            <div className="flex justify-between items-center w-full">
              {isLoading ? <p>loading...</p> : <p>{data?.data?.password}</p>}
              <button
                type="button"
                // variant="outline"
                onClick={ToCopypass}
                className="flex gap-x-2 border-none"
              >
                ກັອບປີ້ລິ້ງ <Copy />
              </button>
            </div>
          </div>
        </form>
        <div className="flex w-full">
          <Button onClick={onClose} className="w-full">
            ສຳເລັດແລ້ວ
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export { Yourself, Board, Workplace, Government };
